import { SuitableSportFilter } from ".";
var SportsMapper = /** @class */ (function () {
    function SportsMapper(sportDataMapper) {
        this.sportDataMapper = sportDataMapper;
    }
    SportsMapper.prototype.map = function (sports) {
        if (!sports || sports.length === 0) {
            return [];
        }
        var mappedResult = sports.map(this.sportDataMapper);
        var filteredResult = mappedResult.filter(function (x) { return x.order >= 0 && x.numberOfEvents !== 0 && SuitableSportFilter(x); });
        return filteredResult;
    };
    SportsMapper.prototype.mapFromPushes = function (sports) {
        if (!sports || sports.length === 0) {
            return [];
        }
        var mappedResult = sports.map(this.sportDataMapper);
        var filteredResult = mappedResult.filter(function (x) { return x.numberOfEvents !== 0 && SuitableSportFilter(x); });
        return filteredResult;
    };
    return SportsMapper;
}());
export { SportsMapper };
//# sourceMappingURL=SportsMapper.js.map